module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/198-argentina-85a31b99ca6c86b718ffb0c724f70968.svg";